import React from "react";
import "./App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "sonner";

// Components
import Header from "./components/Header";
import HeroSlider from "./components/HeroSlider";
import AboutSection from "./components/AboutSection";
import ServicesSection from "./components/ServicesSection";
import ReleasesSection from "./components/ReleasesSection";
import GallerySection from "./components/GallerySection";
import SocialBanner from "./components/SocialBanner";
import ContactSection from "./components/ContactSection";
import Footer from "./components/Footer";
import PromoPopup from "./components/PromoPopup";

const LandingPage = () => {
  return (
    <div className="min-h-screen bg-black">
      <Header />
      <PromoPopup />
      <main>
        <HeroSlider />
        <AboutSection />
        <ServicesSection />
        <ReleasesSection />
        <GallerySection />
        <SocialBanner />
        <ContactSection />
      </main>
      <Footer />
    </div>
  );
};

function App() {
  return (
    <div className="App">
      <Toaster 
        position="top-right" 
        richColors 
        toastOptions={{
          style: {
            fontFamily: 'system-ui, sans-serif',
          },
        }}
      />
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<LandingPage />} />
        </Routes>
      </BrowserRouter>
    </div>
  );
}

export default App;
